import { render, staticRenderFns } from "./employeeDetails.vue?vue&type=template&id=d937e740"
import script from "./employeeDetails.vue?vue&type=script&lang=js"
export * from "./employeeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports